import React from 'react';
import { Course } from '../../types/interfaces';
import { Card, CardContent, Typography, Box, Grid } from '@mui/material';
import EventIcon from '@mui/icons-material/Event';
import SchoolIcon from '@mui/icons-material/School';
import DescriptionIcon from '@mui/icons-material/Description';

interface CourseDetailsProps {
  course: Course;
}

const CourseDetails: React.FC<CourseDetailsProps> = ({ course }) => {
  return (
    <Card sx={{ p: 1.5, mb: 2, backgroundColor: '#f9f9f9' }}>
      <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
        {/* Course Name */}
        <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', color: '#3f51b5', mb: 2 }}>
          {course.name}
        </Typography>

        <Grid container spacing={3}>
          {/* Left Column */}
          <Grid item xs={12} md={6}>
            {/* Course Description */}
            <Box display="flex" alignItems="flex-start" mb={2}>
              <Box display="flex" alignItems="center" sx={{ minWidth: '120px', mr: 2 }}>
                <DescriptionIcon sx={{ mr: 1, color: '#3f51b5' }} />
                <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>Kuvaus:</Typography>
              </Box>
              <Typography variant="body2" sx={{ flex: 1 }}>
                {course.description}
              </Typography>
            </Box>

            {/* Subject */}
            <Box display="flex" alignItems="center" mb={1}>
              <Box display="flex" alignItems="center" sx={{ minWidth: '120px', mr: 2 }}>
                <SchoolIcon sx={{ mr: 1, color: '#3f51b5' }} />
                <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>Aine:</Typography>
              </Box>
              <Typography variant="body2">
                {course.subject}
              </Typography>
            </Box>

            {/* Subject Specification */}
            <Box display="flex" alignItems="flex-start" mb={1}>
              <Box sx={{ minWidth: '120px', mr: 2 }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>Aineen kuvaus:</Typography>
              </Box>
              <Typography variant="body2" sx={{ flex: 1 }}>
                {course.subjectSpecification}
              </Typography>
            </Box>
          </Grid>

          {/* Right Column */}
          <Grid item xs={12} md={6}>
            {/* Start Date */}
            <Box display="flex" alignItems="center" mb={1}>
              <Box display="flex" alignItems="center" sx={{ minWidth: '120px', mr: 2 }}>
                <EventIcon sx={{ mr: 1, color: '#3f51b5' }} />
                <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>Aloituspäivä:</Typography>
              </Box>
              <Typography variant="body2">
                {course.startDate}
              </Typography>
            </Box>

            {/* End Date */}
            <Box display="flex" alignItems="center" mb={1}>
              <Box sx={{ minWidth: '120px', mr: 2 }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>Lopetuspäivä:</Typography>
              </Box>
              <Typography variant="body2">
                {course.endDate}
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default CourseDetails;
